export default __webpack_public_path__ + "static/media/s12.d0ba0149.jpg";